module.exports = __webpack_public_path__ + "img/EASTASIA_LEGUMES.dca1d920.png";